"use client";

import { ArrowDown, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Audithero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  const headlineWords = [{
    text: "Maximize",
    italic: false
  }, {
    text: "Your",
    italic: false
  }, {
    text: "Hotel’s",
    italic: true
  }, {
    text: "Revenue.",
    italic: false
  }];
  return <section data-section-id="2715" id="audithero" className="relative w-full bg-background text-foreground overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-screen">
        {}
        <div ref={leftRef} className="lg:col-span-5 relative flex flex-col justify-between px-6 sm:px-10 lg:px-14 py-12 lg:py-16 order-2 lg:order-1">
          {}
          <div className="hidden lg:block" aria-hidden="true" />

          {}
          <div className="flex flex-col lg:mt-[30vh]">
            {}
            <div className={`font-default text-xs uppercase tracking-widest text-secondary transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            letterSpacing: "0.25em"
          }}>
              01 — Revenue Management Excellence
            </div>

            {}
            <h1 className="font-default font-bold mt-10 leading-[0.95]" style={{
            fontSize: "clamp(3.5rem, 8vw, 7.5rem)",
            letterSpacing: "-0.03em"
          }}>
              {headlineWords.map((word, i) => <span data-index={i} key={i} className="inline-block overflow-hidden align-bottom mr-[0.25em]">
                  <span className={`inline-block transition-all ease-out ${word.italic ? "italic" : ""} ${leftVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
                transitionDuration: "800ms",
                transitionDelay: `${200 + i * 180}ms`
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h1>

            {}
            <p className={`font-default text-base sm:text-lg text-muted-foreground mt-[60px] max-w-[380px] leading-relaxed transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "1000ms"
          }}>
              Unlock your property's full potential with data-driven OTA strategies and expert revenue consulting by Sunil Singh.
            </p>

            {}
            <div className={`flex flex-wrap items-center gap-6 mt-10 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "1200ms"
          }}>
              <Button asChild size="lg" className="rounded-lg px-7 h-12 bg-secondary text-primary-foreground hover:bg-secondary/90 font-default text-sm tracking-wide shadow-md">
                <Link to="/ContactPage">
                  Book a Consultation
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>

              <Link to="#" className="group relative inline-flex items-center gap-2 font-default text-sm text-foreground tracking-wide">
                <span className="relative">
                  View Our Services
                  <span className="absolute left-0 -bottom-0.5 h-px w-full bg-foreground/40 transition-all duration-500 group-hover:bg-foreground" />
                </span>
                <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </Link>
            </div>
          </div>

          {}
          <div className={`flex items-center gap-4 mt-16 lg:mt-0 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "1400ms"
        }}>
            <span className="block h-px w-10 bg-foreground/30" aria-hidden="true" />
            <span className="font-default text-xs uppercase tracking-widest text-muted-foreground">
              Scroll
            </span>
            <ArrowDown className="h-4 w-4 text-muted-foreground animate-bounce" />
          </div>
        </div>

        {}
        <div ref={imgRef} className="lg:col-span-7 relative order-1 lg:order-2 h-[60vh] lg:h-auto lg:min-h-screen overflow-hidden">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_growth_strategy.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_growth_strategy.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_growth_strategy.webp-wvc-sizes" alt="Professional hotel revenue management dashboard showing growth trends" loading="lazy" decoding="async" className={`h-full w-full object-cover transition-all duration-[1400ms] ease-out ${imgVisible ? "scale-100 opacity-100" : "scale-105 opacity-0"}`} />

          {}
          <div className="pointer-events-none absolute inset-0" style={{
          background: "radial-gradient(ellipse at center, transparent 50%, hsla(222, 47%, 7%, 0.55) 100%)"
        }} aria-hidden="true" />

          {}
          <div className={`absolute top-6 right-6 lg:top-10 lg:right-10 font-default text-5xl sm:text-6xl lg:text-7xl text-background/90 select-none transition-all duration-1000 ease-out ${imgVisible ? "opacity-90 translate-y-0" : "opacity-0 -translate-y-2"}`} style={{
          transitionDelay: "800ms"
        }} aria-label="Revenue growth icon">
            
          </div>
        </div>
      </div>
    </section>;
}